import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import ku from "./locales/ku.json";

const savedLang = localStorage.getItem("irqgyp_lang") || "en";

const rtlLanguages = ["ku", "ar"]; // force all to RTL

const setDirection = (lang) => {
  const isRTL = rtlLanguages.includes(lang);

  document.documentElement.dir = isRTL ? "rtl" : "ltr";
  document.documentElement.lang = lang;
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
    ku: { translation: ku },
  },
  lng: savedLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

// set initial direction
setDirection(savedLang);

// listen for language changes
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("irqgyp_lang", lng);
  setDirection(lng);
});

export default i18n;